import { createFileRoute } from '@tanstack/react-router';
import { GroupsTab } from '../../../../features/B4/GroupsTab';

/** Client groups & routing tab: connect a group, routes per purpose, "למי תגיע הודעה?". `?site=` comes from the layout. */
export const Route = createFileRoute('/_app/client/$clientId/groups')({
  component: GroupsTab,
});
